import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Typography, IconButton,Button} from '@mui/material';
import { Search as SearchIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import axios from 'axios';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL'; 
import AddUserDialog from '../Contents/AdminUser/AddAdminUserDialog';
import Loader from '../../../routes/Loader';
import { toast } from 'react-toastify';
import PopupDialog from '../../PopupDialog/PopupDialog';
import SetLoanRegistrationForm from '../Contents/setloan/SetLoanRegistrationForm';
import { Deleterequest, Getrequest } from '../../../context/AxiosRequest';
/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const SetLoan = () => {

  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [StudentData, setStudentData] = useState(null);
  const [CountData, setCountData] = useState(0);
  const rowsPerPage = 6;
  const {  accesstoken, RefreshUesFF,GlobalLoader } = useContext(ContextData);
  const [OpenLoader,setOpenLoader] = useState(false)
  const [ReLoader,setReLoader] = useState(false)
   

  useEffect(() => {

    async function FetchData() {
      try {

           const response = await Getrequest("/auth/get_loan_list",accesstoken)
       

        setCountData(Object.keys(response));
        setStudentData(response);
       

      } catch (err) {
        if (err) console.log(err.message);
      }
    }
    FetchData();

  }, [ReLoader,GlobalLoader]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const List = Object.keys(StudentData !== null && StudentData).map(data => StudentData[data]);
  const filteredUsers = List.filter(user => {
    const lowerCaseSearchText = searchText.toLowerCase().trim();
    return (
      user.qualification_type.toLowerCase().includes(lowerCaseSearchText)
    );
  });

  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const usersToShow = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handleNextPage = () => {
    setCurrentPage(prevPage => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage(prevPage => prevPage - 1);
  };

  const HanldeRemove = async (tokens) => {
     
    setOpenLoader(true)

    try {

    const response = await Deleterequest("/auth/remove_set_loan/"+tokens,accesstoken)
      
    toast.success(response)
    
    setOpenLoader(false)
    setReLoader(!ReLoader)

    } catch (err) {
      setOpenLoader(false)
      if (err) console.log(err.message);
    }




  }

  return (
    <div className="con-dev" style={{ width: "100%", height: "100%" }}>
      <Loader
      OpenLoader={OpenLoader}
       />
      <Container>
        <Typography variant="h4" gutterBottom className='flex justify-between items-center'>
          <p className='font-extrabold mt-3'>Set Loan</p>
          <div>
            <SetLoanRegistrationForm />
          </div>
        </Typography> 

        <TextField
          label="Search"
          variant="outlined"
          value={searchText}
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: (
              <IconButton>
                <SearchIcon />
              </IconButton>
            ),
          }}
          fullWidth
          margin="normal"
        />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ background: "rgb(0, 24, 69)" }}>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>No</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Loan Name</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Loan Type</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Qualification Type</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Residential Type</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Will Pay</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Amount to Pay</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Description</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Remove</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {usersToShow.map((user, index) => (
                <TableRow key={user.id}>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{index + 1}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.loan_name}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.loan_type}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.qualification_type}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.residential_type}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.will_pay}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.amount_to_pay}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}><PopupDialog type="set_loan" value={user.loan_description} /></TableCell>
                  <TableCell align='center'>
                    
                    <Button className='Hover-' onClick={() => HanldeRemove(user.token)} elevation={10} sx={{ whiteSpace: 'nowrap', fontSize: '14px', backgroundColor: 'rgb(199, 1, 1)', margin: '9px 0px' }} size="large" variant="contained">
                      Remove
                    </Button>

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {totalPages > 1 && (
          <div>
            {currentPage > 1 && (
              <Button className='Hover-' onClick={handlePrevPage} elevation={10} sx={{ whiteSpace: 'nowrap', fontSize: '14px', backgroundColor: 'rgb(0, 24, 69)', color: "white", margin: '9px 4px' }} size="large" variant="contained">
                <ArrowBackIcon />
              </Button>
            )}
            <span>Page {currentPage} of {totalPages}</span>
            {currentPage < totalPages && (
              <Button className='Hover-' onClick={handleNextPage} elevation={10} sx={{ whiteSpace: 'nowrap', fontSize: '14px', backgroundColor: 'rgb(0, 24, 69)', color: "white", margin: '9px 4px' }} size="large" variant="contained">
                <ArrowForwardIcon />
              </Button>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default SetLoan;


// get_data_adminuser